var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notFind"},[_c('img',{attrs:{"src":require("../assets/images/404.jpg"),"alt":""}}),_c('el-button',{attrs:{"type":"primary","round":""},on:{"click":_vm.backHome}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }